import Layout from "../components/Layout"

const IndexPage = () => (
  <Layout title="Penusa | FAQ">
    <div className="container-fluid" id="faq-page-header">
      <div className="background-img">
            <h1 className="title">Frequently Asked Questions</h1>
      </div>
    </div>
    <div className="container faq">
      <div className="row">
        <div className="col-12 faq-question">
          <h2>How do I customize my order?</h2>
          <p>When you add an item to the cart, please add any customizations in the "Custom Instructions" field. Include all of the information regarding your order. Note, some products will have size or material requirements. We will reach out to coordinate any issues.</p>
        </div>
        <div className="col-12 faq-question">
          <h2>How do I make a change to my order?</h2>
          <p>In order to satisfy you to the best of our abilities, we believe in direct communication with our clients. Please call or e-mail us for any changes and we shall respond within 2-3 business days.</p>
        </div>
        <div className="col-12 faq-question">
          <h2>Can I order less than the minimum quantity?</h2>
          <p>Yes, you can! However, the price may differ for smaller quantities. Send your request and we will provide a quote for you.</p>
        </div>
        <div className="col-12 faq-question">
          <h2>What's the return policy?</h2>
          <p>Unfortunately, we do not support returns as all of our products are personalized.</p>
        </div>
        <div className="col-12 faq-question">
          <h2>What's the warranty?</h2>
          <p><b>Limited Lifetime Warranty for Penusa Writing Instruments</b></p>
          <p>Penusa writing instruments are designed with superior quality materials and with outstanding workmanship to ensure a final product of exceptional caliber.  Our writing instruments are absolutely guaranteed against mechanical failure, irrespective of age.</p>
          <p>Any Penusa writing instrument or part needing service under this warranty will be repaired or replaced at no charge when received at our service center. (Proof of purchase required.  Postage and insurance are the client’s responsibility and processing fees may apply). Any such item that is no longer available and/or cannot be repaired will be replaced by an equivalent Penusa product.</p>
          <p><b>Warranty Exclusion:</b> Ink refills, erasers, and leads depleted from normal use, damage caused by impact, unreasonable use and/or obvious abuse.</p>
          <p>Note: The Penusa Limited Lifetime Warranty applies only to Penusa writing instruments.
            <br/>
            Please register for our Lifetime Warranty by filling out your information below!</p>
        </div>
      </div>
    </div>
  </Layout>
)

export default IndexPage
